<template>
  <div class="music-player">
    <div class="player-content">
      <div class="playing-title">{{ currentSong.name }}</div>
      <div class="progress-control">
        <span class="time-text">{{ formatTime(currentTime) }}</span>
        <input type="range" min="0" :max="duration || 100" step="0.1" v-model="currentTime" @input="adjustProgress"
          class="progress-slider">
        <span class="time-text">{{ formatTime(duration) }}</span>
      </div>
      <!-- 循环模式 -->
      <div class="control-btns">
        <button class="player-btn" @click="togglePlayMode">
          <img v-if="playMode === 0" src="@/assets/svg/arrows-repeat.svg" class="icon svg-icon" alt="列表循环">
          <img v-else-if="playMode === 1" src="@/assets/svg/shuffle.svg" class="icon svg-icon"
            :class="{ active: playMode !== 0 }" alt="乱序播放">
          <img v-else src="@/assets/svg/arrows-repeat-1.svg" class="icon svg-icon" :class="{ active: playMode !== 0 }"
            alt="单曲循环">
        </button>
        <!-- 切歌、播放暂停 -->
        <button class="player-btn" @click="prevSong" :disabled="songList.length <= 1">
          <img src="@/assets/svg/angle-double-left.svg" class="icon svg-icon" alt="上一首">
        </button>
        <button class="player-btn play-btn" @click="togglePlay">
          <img v-if="!isPlaying" src="@/assets/svg/play.svg" class="icon svg-icon play-icon" alt="播放">
          <img v-else src="@/assets/svg/pause.svg" class="icon svg-icon play-icon" alt="暂停">
        </button>
        <button class="player-btn" @click="nextSong" :disabled="songList.length <= 1">
          <img src="@/assets/svg/angle-double-right.svg" class="icon svg-icon" alt="下一首">
        </button>
        <!-- 音量调节 -->
        <div class="volume-wrapper" @mouseenter="showVolume = true" @mouseleave="hideVolume = true">
          <button class="player-btn volume-btn">
            <img src="@/assets/svg/volume.svg" class="icon svg-icon" :class="volume === 0 ? 'volume-mute' : ''"
              alt="音量">
          </button>
          <div class="volume-popup" v-show="showVolume" @mouseenter="showVolume = true" @mouseleave="hideVolume = true"
            @click.stop>
            <input type="range" min="0" max="1" step="0.05" v-model="volume" @input="adjustVolume" class="volume-slider"
              orient="vertical">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Howl, Howler } from 'howler';

export default {
  name: 'MusicPlayer',
  data() {
    return {
      songList: [
        {
          name: '等温相拥',
          url: require('@/assets/music/雪音音 - 等温相拥.mp3')
        },
        {
          name: '等温相拥 伴奏',
          url: require('@/assets/music/雪音音 - 等温相拥 伴奏.mp3')
        },
        {
          name: '致隅光里的',
          url: require('@/assets/music/雪音音 - 致隅光里的.mp3')
        }
      ],
      currentIndex: 0,
      isPlaying: false,
      playMode: 0,
      volume: 0.7,
      sound: null,
      currentTime: 0,
      duration: 0,
      progressTimer: null,
      showVolume: false,
      hideVolume: false
    };
  },
  computed: {
    currentSong() {
      return this.songList[this.currentIndex] || { name: '暂无歌曲' };
    }
  },
  mounted() {
    this.initAudio();
    Howler.volume(this.volume);
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    clearInterval(this.progressTimer);
    if (this.sound) {
      this.sound.unload();
    }
    document.removeEventListener('click', this.handleDocumentClick);
  },
  watch: {
    hideVolume(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.showVolume = false;
          this.hideVolume = false;
        }, 200);
      }
    }
  },
  methods: {
    formatTime(seconds) {
      if (!seconds || isNaN(seconds)) return '00:00';
      const min = Math.floor(seconds / 60);
      const sec = Math.floor(seconds % 60);
      return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
    },
    initAudio() {
      if (this.songList.length === 0) return;
      clearInterval(this.progressTimer);
      if (this.sound) {
        this.sound.unload();
      }
      this.sound = new Howl({
        src: [this.currentSong.url],
        html5: true,
        volume: this.volume,
        onload: () => {
          this.duration = this.sound.duration();
        },
        onend: () => {
          this.handleSongEnd();
        }
      });
      this.progressTimer = setInterval(() => {
        if (this.isPlaying && this.sound) {
          this.currentTime = this.sound.seek();
        }
      }, 1000);
    },
    handleSongEnd() {
      if (this.songList.length <= 1) {
        if (this.playMode === 2) {
          this.sound.seek(0);
          this.sound.play();
        } else {
          this.isPlaying = false;
          this.currentTime = 0;
        }
        return;
      }
      if (this.playMode === 2) {
        this.sound.seek(0);
        this.sound.play();
      } else {
        this.nextSong();
      }
    },
    togglePlay() {
      if (!this.sound) this.initAudio();
      this.isPlaying ? this.sound.pause() : this.sound.play();
      this.isPlaying = !this.isPlaying;
    },
    prevSong() {
      if (this.songList.length <= 1) return;
      if (this.playMode === 2) return;
      if (this.playMode === 1) {
        let randomIndex = this.currentIndex;
        while (randomIndex === this.currentIndex) {
          randomIndex = Math.floor(Math.random() * this.songList.length);
        }
        this.currentIndex = randomIndex;
      } else {
        this.currentIndex = this.currentIndex === 0 ? this.songList.length - 1 : this.currentIndex - 1;
      }
      this.switchSong();
    },
    nextSong() {
      if (this.songList.length <= 1) return;
      if (this.playMode === 2) return;
      if (this.playMode === 1) {
        let randomIndex = this.currentIndex;
        while (randomIndex === this.currentIndex) {
          randomIndex = Math.floor(Math.random() * this.songList.length);
        }
        this.currentIndex = randomIndex;
      } else {
        this.currentIndex = (this.currentIndex + 1) % this.songList.length;
      }
      this.switchSong();
    },
    switchSong() {
      clearInterval(this.progressTimer);
      this.sound && this.sound.unload();
      this.currentTime = 0;
      this.initAudio();
      this.sound.play();
      this.isPlaying = true;
    },
    togglePlayMode() {
      this.playMode = (this.playMode + 1) % 3;
    },
    adjustVolume() {
      Howler.volume(this.volume);
      this.sound && this.sound.volume(this.volume);
    },
    adjustProgress() {
      this.sound && this.sound.seek(this.currentTime);
    },
    handleDocumentClick() {
      this.showVolume = false;
      this.hideVolume = false;
    }
  }
};
</script>

<style scoped>
.music-player {
  width: 100%;
  background: #000;
  color: #fff;
  padding: 10px 15px;
  font-size: 14px;
}

.player-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.playing-title {
  font-size: 16px;
  color: #ffad32;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
  letter-spacing: 1px;
}

.progress-control {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 90%;
}

.time-text {
  font-size: 12px;
  color: #ccc;
  width: 40px;
  text-align: center;
}

.progress-slider {
  flex: 1;
  height: 4px;
  background: #333;
  outline: none;
  border-radius: 2px;
  -webkit-appearance: none;
}

.progress-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #ffad32;
  cursor: pointer;
  transition: all 0.2s;
}

.progress-slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
}

.control-btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 90%;
}

.player-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.svg-icon {
  width: 20px;
  height: 20px;
  filter: invert(70%) sepia(72%) saturate(600%) hue-rotate(352deg) brightness(100%) contrast(98%);
  transition: all 0.2s;
}

.play-icon {
  width: 22px;
  height: 22px;
  filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(100%) contrast(100%);
}

.player-btn:disabled .svg-icon {
  filter: invert(50%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(90%) contrast(90%);
  cursor: not-allowed;
}

.volume-mute {
  filter: invert(50%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(90%) contrast(90%);
}

.play-btn {
  width: 42px;
  height: 42px;
  background: #ffad32;
}

.play-btn:hover {
  background: #ffa117;
  transform: scale(1.05);
}

.volume-wrapper {
  position: relative;
}

.volume-popup {
  position: absolute;
  top: -100px;
  left: 50%;
  transform: translateX(-50%);
  background: #111;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 99;
  width: 16px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.volume-slider {
  width: 80px;
  height: 12px;
  background: #333;
  outline: none;
  border-radius: 2px;
  -webkit-appearance: none;
  transform: rotate(270deg);
}

.volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffad32;
  cursor: pointer;
}
</style>